<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.7059 21.8194L10.3242 21.6104C5.57637 20.8923 2 16.7871 2 11.8643C2 6.41525 6.41525 2 11.8643 2C17.3133 2 21.7285 6.41525 21.7285 11.8643C21.7285 16.7955 18.1099 20.8935 13.3704 21.6104L11.9887 21.8194V21.8622L11.8473 21.8408L11.7059 21.8622V21.8194ZM15.1222 14.3077H13.1539V20.1787C13.6523 20.1033 14.1363 19.984 14.6018 19.8248C17.9076 18.6941 20.2806 15.553 20.2806 11.8643C20.2806 7.21494 16.5136 3.44797 11.8643 3.44797C7.21494 3.44797 3.44797 7.21494 3.44797 11.8643C3.44797 15.5525 5.79413 18.6932 9.09277 19.8243C9.55779 19.9838 10.0418 20.1033 10.5407 20.1787V14.3077H8.40272V11.8643H10.5407V10.0317C10.5407 7.92761 11.7964 6.73982 13.6968 6.73982C14.6471 6.73982 15.5973 6.90951 15.5973 6.90951V8.97964H14.5453C13.4932 8.97964 13.1539 9.62444 13.1539 10.3032V11.8643H15.4955L15.1222 14.3077Z"
    fill="currentColor"
  />
</svg>
